import {
  Break,
  ButtonBack,
  ButtonPlay,
  ButtonPlayWrapper,
  ButtonRestart,
  ControlWrapper,
  Root,
  Separator,
  Time,
  TimeWrapper,
  Wave
} from './styles';
import React, { useEffect, useState } from 'react';

import IconSVG from '../Icon/IconSVG';
import styled from 'styled-components';
import theme from '../../theme';

function fmtMSS(s) {
  return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
}

function AudioPlayer({ url }) {
  const [audio, setAudio] = useState(null);
  const [playing, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [waveId, setWaveId] = useState(null);

  useEffect(() => {
    setWaveId(`waveform-${Math.floor(Math.random() * 100)}`);
  }, []);

  useEffect(
    () => {
      if (waveId) {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/wavesurfer.js';
        script.async = true;

        script.onload = () => {
          const wavesurfer = WaveSurfer.create({
            container: `#${waveId}`,
            waveColor: '#D9DCDE',
            progressColor: theme.color.brand.primary,
            cursorColor: '#fff',
            partialRender: true,
            height: 44,
            barGap: 4,
            barWidth: 4
          });

          wavesurfer.load(url);

          wavesurfer.on('ready', () => {
            setAudio(wavesurfer);
            const totalTime = wavesurfer.getDuration();
            setTotalTime(totalTime);
          });
          wavesurfer.on('error', e => {
            console.error('error', e);
            setAudio(wavesurfer);
          });

          wavesurfer.on('audioprocess', function() {
            if (wavesurfer.isPlaying()) {
              const currentTime = wavesurfer.getCurrentTime();
              setCurrentTime(currentTime);
            }
          });
        };

        document.body.appendChild(script);
      }
    },
    [waveId]
  );

  const togglePlay = () => {
    if (audio) {
      if (audio.isPlaying()) {
        audio.pause();
        setIsPlaying(false);
      } else {
        audio.play();
        setIsPlaying(true);
      }
    }
  };

  const restartAudio = () => {
    if (audio) {
      audio.seekTo(0);
      audio.pause();
      setIsPlaying(false);
      setCurrentTime(0);
    }
  };

  const backAudio = () => {
    if (audio) {
      const toTime = currentTime < 5 ? 0 : currentTime - 5;
      const toProgress = toTime / totalTime;
      audio.seekTo(toProgress);
      audio.play();
    }
  };

  return (
    <Root>
      <ControlWrapper>
        <ButtonRestart onClick={restartAudio}>
          <IconSVG name="restart" />
        </ButtonRestart>
        <ButtonBack onClick={backAudio}>
          <IconSVG left={-2} name="minus5" />
        </ButtonBack>
      </ControlWrapper>
      <ButtonPlayWrapper>
        <ButtonPlay onClick={togglePlay}>
          {playing && playing ? (
            <IconSVG name="pause" top={1} left={0} />
          ) : (
            <IconSVG top={1} left={1} name="play" />
          )}
        </ButtonPlay>
      </ButtonPlayWrapper>
      <Wave id={waveId} />
      <TimeWrapper>
        <Time>{fmtMSS(Math.floor(currentTime))}</Time>
        <Separator />
        <Time>{fmtMSS(Math.floor(totalTime))}</Time>
      </TimeWrapper>
    </Root>
  );
}

export default AudioPlayer;
